module.exports = __webpack_public_path__ + "static/social-fb-1cb8a31ed6acc40d0c7bcd27f2b928e3.png";